import { UtilsService } from 'app/modules/utils-service';
import { CommonModule } from '@angular/common';
import { Component, computed, Inject, inject, model, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DocumentosEmitidosService } from '../documentos-emitidos.service';
import { CONSTANTS } from './../../../../../../../core/constants';
import { TipologiasInterface } from 'app/models/tipologias.model';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { DataTiposGestionesBienesCulturales, ResponseTiposGestionesBienesCulturales } from '../models/gestiones-bienes-culturales';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { GenerarDocuentoInterface } from '../models/generar-documento.model';
import { FuseAlertComponent } from '@fuse/components/alert';
import { Plantilla } from 'app/modules/admin/documentos-oficiales/models/plantillas.model';

@Component({
    selector: 'form-emitir-documento',
    templateUrl: 'form-documento.component.html',
    imports:[
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        FormsModule,
        MatButtonModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        MatTableModule,
        FuseAlertComponent
    ]
})

export class FormDocumentoComponent implements OnInit {
    tipoDocumentos:TipologiasInterface[]
    tiposDocumentosFicha:TipologiasInterface[]
    tiposGestionesBienesCulturales: DataTiposGestionesBienesCulturales[] = []
    ListPersonas:any[]
    documentoGenerado:GenerarDocuentoInterface= new GenerarDocuentoInterface

    gestionActual: string = '';
    gestionesSeleccionadas: DataTiposGestionesBienesCulturales[] = [];
    filteredGestiones: DataTiposGestionesBienesCulturales[] = [];
    
    isLoading:boolean= false
    esFicha:boolean= false

    seccionBienCultural:number
    plantillas: Plantilla[]=[]

    TIPOLOGIA_ID_FICHA_DE_REGISTRO:number= CONSTANTS.TIPOLOGIA_ID_FICHA_DE_REGISTRO


    constructor(
        private documetosEmitidosService:DocumentosEmitidosService,
        public dialogRef: MatDialogRef<FormDocumentoComponent>,
        private router: Router,
        private utilsService:UtilsService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { 
        this.getTipoRepresentacion()
        this.getTiposGestionesBines()
        
    }

    ngOnInit() { 
        this.filteredGestiones = this.tiposGestionesBienesCulturales.slice(); 

        this.esFicha= this.data.esFicha
        this.seccionBienCultural= this.data.seccion

        if (!this.esFicha) {
            this.getPlantillas()

        }
        
    }

    onInputChange() {
        const current = this.gestionActual.toLowerCase();
        if (current) {
        this.filteredGestiones = this.tiposGestionesBienesCulturales.filter(g =>
            g.nombre.toLowerCase().includes(current) &&
            !this.gestionesSeleccionadas.some(sel => sel.gestionUuid === g.gestionUuid)
        );
        } else {
        this.filteredGestiones = this.tiposGestionesBienesCulturales.slice();
        }
    }

    remove(gestion: DataTiposGestionesBienesCulturales): void {
        this.gestionesSeleccionadas = this.gestionesSeleccionadas.filter(g => g.gestionUuid !== gestion.gestionUuid);
        this.onInputChange();
    }

    selected(event: MatAutocompleteSelectedEvent) {
        const nombreSeleccionado = event.option.value;
        const gestion = this.tiposGestionesBienesCulturales.find(g => g.nombre === nombreSeleccionado);

        if (gestion && !this.gestionesSeleccionadas.some(g => g.gestionUuid === gestion.gestionUuid)) {
            this.gestionesSeleccionadas = [...this.gestionesSeleccionadas, gestion];
        }

    }

    /*abrirGestion(gestionUuid){
        this.router.navigateByUrl(`/task-details/task/${gestionUuid}`)    
    }*/

    getTipoRepresentacion(){
        this.documetosEmitidosService.getTipologiaDocumentosEmitidos(CONSTANTS.TIPOLOGIA_PADRE_ID_TIPO_DOCUMETNO)
            .then((response:TipologiasInterface[])=>{
                this.tiposDocumentosFicha= response
                if(this.esFicha){
                    this.documentoGenerado.tipoDocumento= this.tiposDocumentosFicha.find(item=> item.tipologiaId=== CONSTANTS.TIPOLOGIA_ID_FICHA_DE_REGISTRO)
                }
            }) 
    }

    getPlantillas() {
        this.documetosEmitidosService.getPlantillas(this.seccionBienCultural)
        .then((response: Plantilla[]) => {
            this.plantillas = response;

            // Convertir cada plantilla a un objeto del tipo TipologiasInterface
            const plantillasConvertidas: TipologiasInterface[] = response.map((plantilla) => ({
                tipologiaId: plantilla.plantillaId,
                tipologiaPadreId: 0, // Usa un ID identificador para plantillas
                descripcion: plantilla.nombreDocumento,
                valor1: '',
                valor2: '',
                valor3: '',
                tipologias: [],
            }));

            // Agregar las plantillas convertidas al listado original
            this.tipoDocumentos =  plantillasConvertidas;
        });
    }

    getTiposGestionesBines(){
        this.documetosEmitidosService.getGestionesByBienesCulturales()
            .then((response:ResponseTiposGestionesBienesCulturales)=>{
                this.tiposGestionesBienesCulturales= response.data
            })
    }

    emitirFichaDocumento(esFicha: boolean) {
        const metodo = esFicha 
            ? this.documetosEmitidosService.postFichaDeRegistro.bind(this.documetosEmitidosService)
            : this.documetosEmitidosService.postDocumento.bind(this.documetosEmitidosService);
        
        this.emitirDocumento(metodo);
    }

    private emitirDocumento(metodo: (data: any) => Promise<any>) {
        this.isLoading = true;
        this.documentoGenerado.bienCulturalUuid = this.data.uu_id;
        this.documentoGenerado.GestionesUuid = this.gestionesSeleccionadas.map(g => g.gestionUuid);

        if (this.documentoGenerado.bienCulturalUuid && this.documentoGenerado.GestionesUuid) {

            this.documentoGenerado.plantillaId =  (this.esFicha) ? 0 : this.documentoGenerado.tipoDocumento?.tipologiaId;
            metodo(this.documentoGenerado)
                .then(response => {
                    this.utilsService.openSuccessSnakBar('Documento emitido correctamente');
                    this.documetosEmitidosService.getDocumentosGenerados(this.documentoGenerado.bienCulturalUuid);
                    this.dialogRef.close(true);
                })
                .catch(error => {
                    console.error('Error al emitir documento:', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        } else {
            this.isLoading = false;
        }
    }

    crearFicha(){
        this.isLoading= true
        this.documentoGenerado.bienCulturalUuid=this.data.uu_id
        this.documentoGenerado.GestionesUuid = this.gestionesSeleccionadas.map(g => g.gestionUuid);
        if(this.documentoGenerado.bienCulturalUuid && this.documentoGenerado.GestionesUuid){
            this.documetosEmitidosService.postFichaDeRegistro(this.documentoGenerado)
            .then(response=>{
                this.utilsService.openSuccessSnakBar('Documento emitido correctamente')
                this.documetosEmitidosService.getDocumentosGenerados(this.documentoGenerado.bienCulturalUuid)
                this.dialogRef.close(true);
                this.isLoading= false
            })
            .catch(error => {
                this.isLoading = false;
            });
        }
    }
}